module.exports = __webpack_public_path__ + "02_medium_gray.084c58ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/02_medium_gray.png
// module id = Zdcl
// module chunks = 0